import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "accouting-box"
};
const _hoisted_2 = {
  class: "product-money"
};
const _hoisted_3 = {
  key: 0,
  class: "button-primary"
};
const _hoisted_4 = {
  class: "unit"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "line-height": "15px"
  }
};
const _hoisted_6 = {
  class: "unit"
};
const _hoisted_7 = {
  class: "amount"
};
const _hoisted_8 = {
  class: "unit"
};
const _hoisted_9 = {
  class: "unit"
};
const _hoisted_10 = {
  class: "unit"
};
const _hoisted_11 = {
  key: 0,
  class: "save"
};
const _hoisted_12 = {
  key: 0,
  class: "deal-content"
};
const _hoisted_13 = {
  class: "product-selected"
};
const _hoisted_14 = {
  class: "selected"
};
const _hoisted_15 = {
  class: "text"
};
import { computed, ref, watch, reactive } from 'vue';
import { priceSplice, getAppConfig } from '@/utils/common';
import { findOptimalPromotion } from '@/views/spc/orderConfirm/components/SPCAccountingBox';
import CountDown from '@/components/countDown/CountDown.vue';
import constants from '@/constants';
import { useI18n } from 'vue-i18n';
const MAX_AMOUNT_PRICE = 9999;
export default {
  __name: 'BuyAccountingBox',
  props: {
    asinDetails: {
      type: Object,
      default: () => ({
        ourPrice: {
          amount: ''
        },
        specificationText: ''
      })
    },
    quantity: {
      type: Number
    },
    promotionInfoList: {
      type: Array,
      default: () => []
    },
    selectedTwister: {
      type: Object,
      default: () => {}
    }
  },
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const DEAL_TYPE = {
      DEAL_OF_THE_DAY: {
        priceText: t('modules.checkout.DOTD_DISCOUNTED_PRICE'),
        text: t('modules.checkout.TODAY_DEAL'),
        key: 'dotdPrice'
      },
      BEST_DEAL: {
        priceText: t('modules.checkout.BEST_DEAL_PRICE'),
        text: t('modules.checkout.BEST_DEAL'),
        key: 'bestPrice'
      }
    };
    const GREY_TIP = `${constants.IMAGE_URL}assets/svg/greyTip.svg`;
    const PRICE_REDUCTION = `${constants.IMAGE_URL}assets/svg/icon/priceReductionIcon.png`;
    const optimalPromotion = ref(null);
    const promotionsList = ref([]);
    const isEndDealTime = ref(false);
    const popupConfig = reactive({
      isShow: false,
      title: '',
      content: ''
    });
    const amountTextClass = computed(() => {
      var _props$asinDetails$ou;
      return ((_props$asinDetails$ou = props.asinDetails.ourPrice) === null || _props$asinDetails$ou === void 0 ? void 0 : _props$asinDetails$ou.amount) > MAX_AMOUNT_PRICE ? 'max-amount' : '';
    });
    const getOptimalPromotion = () => {
      var _props$asinDetails$ou2;
      optimalPromotion.value = findOptimalPromotion(promotionsList.value, Number((_props$asinDetails$ou2 = props.asinDetails.ourPrice) === null || _props$asinDetails$ou2 === void 0 ? void 0 : _props$asinDetails$ou2.amount));
    };
    const cptPostCouponPrice = computed(() => {
      var _props$asinDetails$ou3, _optimalPromotion$val;
      let price = 0;
      price = ((_props$asinDetails$ou3 = props.asinDetails.ourPrice) === null || _props$asinDetails$ou3 === void 0 ? void 0 : _props$asinDetails$ou3.amount) - ((_optimalPromotion$val = optimalPromotion.value) === null || _optimalPromotion$val === void 0 ? void 0 : _optimalPromotion$val.amount);
      return price;
    });
    const cptDealRemainingTime = computed(() => {
      var _props$asinDetails, _props$asinDetails$de;
      return ((_props$asinDetails = props.asinDetails) === null || _props$asinDetails === void 0 ? void 0 : (_props$asinDetails$de = _props$asinDetails.dealOffer) === null || _props$asinDetails$de === void 0 ? void 0 : _props$asinDetails$de.endTime) - new Date().getTime();
    });
    const cptDealTypeText = computed(() => {
      var _DEAL_TYPE$props$asin, _DEAL_TYPE$props$asin2, _props$asinDetails2, _props$asinDetails2$d;
      return (_DEAL_TYPE$props$asin = (_DEAL_TYPE$props$asin2 = DEAL_TYPE[(_props$asinDetails2 = props.asinDetails) === null || _props$asinDetails2 === void 0 ? void 0 : (_props$asinDetails2$d = _props$asinDetails2.dealOffer) === null || _props$asinDetails2$d === void 0 ? void 0 : _props$asinDetails2$d.dealType]) === null || _DEAL_TYPE$props$asin2 === void 0 ? void 0 : _DEAL_TYPE$props$asin2.text) !== null && _DEAL_TYPE$props$asin !== void 0 ? _DEAL_TYPE$props$asin : '';
    });
    const dealPriceText = computed(() => {
      var _DEAL_TYPE$props$asin3, _DEAL_TYPE$props$asin4, _props$asinDetails3, _props$asinDetails3$d;
      return (_DEAL_TYPE$props$asin3 = (_DEAL_TYPE$props$asin4 = DEAL_TYPE[(_props$asinDetails3 = props.asinDetails) === null || _props$asinDetails3 === void 0 ? void 0 : (_props$asinDetails3$d = _props$asinDetails3.dealOffer) === null || _props$asinDetails3$d === void 0 ? void 0 : _props$asinDetails3$d.dealType]) === null || _DEAL_TYPE$props$asin4 === void 0 ? void 0 : _DEAL_TYPE$props$asin4.priceText) !== null && _DEAL_TYPE$props$asin3 !== void 0 ? _DEAL_TYPE$props$asin3 : '';
    });
    const selectedTwisterValues = computed(() => {
      const textArray = Object.values(props.selectedTwister);
      const isAllNull = textArray.every(item => item === null);
      if (isAllNull) {
        return '';
      }
      return `${textArray.filter(item => item).toString()},`;
    });
    const dealTimeFinish = () => {
      isEndDealTime.value = true;
    };
    const getTipText = async () => {
      var _props$asinDetails4, _props$asinDetails4$d;
      const configData = await getAppConfig(constants.ENUM_APP_CONFIG_TYPE.DETAIL_PAGE);
      const configKey = DEAL_TYPE[(_props$asinDetails4 = props.asinDetails) === null || _props$asinDetails4 === void 0 ? void 0 : (_props$asinDetails4$d = _props$asinDetails4.dealOffer) === null || _props$asinDetails4$d === void 0 ? void 0 : _props$asinDetails4$d.dealType].key;
      popupConfig.title = configData[configKey].title;
      popupConfig.content = configData[configKey].content;
      popupConfig.isShow = true;
    };
    watch(() => {
      var _props$asinDetails5, _props$asinDetails5$o;
      return [(_props$asinDetails5 = props.asinDetails) === null || _props$asinDetails5 === void 0 ? void 0 : (_props$asinDetails5$o = _props$asinDetails5.ourPrice) === null || _props$asinDetails5$o === void 0 ? void 0 : _props$asinDetails5$o.amount, props.quantity];
    }, ([newPriceAmount, newQuantity]) => {
      if (newPriceAmount || newQuantity) {
        getOptimalPromotion();
      }
    });
    watch(() => props.promotionInfoList, value => {
      if (value) {
        promotionsList.value = value.map(item => {
          return {
            amount: item.benefitsAmount,
            id: item.id,
            text: item.text,
            threshold: item.thresholdAmount
          };
        });
        getOptimalPromotion();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _optimalPromotion$val2, _props$asinDetails$o, _optimalPromotion$val3, _optimalPromotion$val4, _props$asinDetails$o2, _props$asinDetails$o3, _optimalPromotion$val5, _props$asinDetails$o4, _optimalPromotion$val6, _optimalPromotion$val7, _props$asinDetails$o5, _optimalPromotion$val8, _optimalPromotion$val9, _props$asinDetails$o6, _props$asinDetails$o7, _optimalPromotion$val10, _props$asinDetails$o8;
      const _component_pop_up = _resolveComponent("pop-up");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_optimalPromotion$val2 = optimalPromotion.value) !== null && _optimalPromotion$val2 !== void 0 && _optimalPromotion$val2.text || ((_props$asinDetails$o = __props.asinDetails.ourPrice) === null || _props$asinDetails$o === void 0 ? void 0 : _props$asinDetails$o.type) === _unref(constants).OUR_PRICE_TYPE.DEAL ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_optimalPromotion$val3 = optimalPromotion.value) !== null && _optimalPromotion$val3 !== void 0 && _optimalPromotion$val3.text ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('common.AFTER')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.COUPON')), 1)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(dealPriceText.value), 1)], 64)), _createTextVNode(" " + _toDisplayString(_ctx.$t('common.currencyUnit')), 1)]), (_optimalPromotion$val4 = optimalPromotion.value) !== null && _optimalPromotion$val4 !== void 0 && _optimalPromotion$val4.text ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: _normalizeClass(["amount", amountTextClass.value])
      }, _toDisplayString(_unref(priceSplice)(cptPostCouponPrice.value)[0]), 3), _createElementVNode("div", _hoisted_6, "." + _toDisplayString(_unref(priceSplice)(cptPostCouponPrice.value)[1]), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(priceSplice)((_props$asinDetails$o2 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o2 === void 0 ? void 0 : _props$asinDetails$o2.amount)[0]), 1), _createElementVNode("div", _hoisted_8, " ." + _toDisplayString(_unref(priceSplice)((_props$asinDetails$o3 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o3 === void 0 ? void 0 : _props$asinDetails$o3.amount)[1]), 1)], 64))])) : _createCommentVNode("", true), !((_optimalPromotion$val5 = optimalPromotion.value) !== null && _optimalPromotion$val5 !== void 0 && _optimalPromotion$val5.text) && ((_props$asinDetails$o4 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o4 === void 0 ? void 0 : _props$asinDetails$o4.type) === _unref(constants).OUR_PRICE_TYPE.DEAL ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "tip",
        onClick: getTipText,
        src: GREY_TIP,
        alt: ""
      })) : _createCommentVNode("", true), (_optimalPromotion$val6 = optimalPromotion.value) !== null && _optimalPromotion$val6 !== void 0 && _optimalPromotion$val6.text || !((_optimalPromotion$val7 = optimalPromotion.value) !== null && _optimalPromotion$val7 !== void 0 && _optimalPromotion$val7.text) && ((_props$asinDetails$o5 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o5 === void 0 ? void 0 : _props$asinDetails$o5.type) !== _unref(constants).OUR_PRICE_TYPE.DEAL ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["price", {
          'default-price': !((_optimalPromotion$val8 = optimalPromotion.value) !== null && _optimalPromotion$val8 !== void 0 && _optimalPromotion$val8.text)
        }])
      }, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('common.currencyUnit')), 1), _createElementVNode("div", {
        class: _normalizeClass(["amount", (_optimalPromotion$val9 = optimalPromotion.value) !== null && _optimalPromotion$val9 !== void 0 && _optimalPromotion$val9.text ? amountTextClass.value : ''])
      }, _toDisplayString(_unref(priceSplice)((_props$asinDetails$o6 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o6 === void 0 ? void 0 : _props$asinDetails$o6.amount)[0]), 3), _createElementVNode("div", _hoisted_10, " ." + _toDisplayString(_unref(priceSplice)((_props$asinDetails$o7 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o7 === void 0 ? void 0 : _props$asinDetails$o7.amount)[1]), 1), (_optimalPromotion$val10 = optimalPromotion.value) !== null && _optimalPromotion$val10 !== void 0 && _optimalPromotion$val10.text ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("img", {
        src: PRICE_REDUCTION,
        alt: ""
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('common.SAVE') + _ctx.$t('common.currencyUnit')) + _toDisplayString(optimalPromotion.value.amount.toFixed(2)), 1)])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)]), ((_props$asinDetails$o8 = __props.asinDetails.ourPrice) === null || _props$asinDetails$o8 === void 0 ? void 0 : _props$asinDetails$o8.type) === _unref(constants).OUR_PRICE_TYPE.DEAL && !isEndDealTime.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createTextVNode(_toDisplayString(cptDealTypeText.value) + " ", 1), _createElementVNode("span", null, _toDisplayString(_unref(t)('common.TIME_REMAINING')), 1), _createVNode(CountDown, {
        onFinish: dealTimeFinish,
        time: cptDealRemainingTime.value
      }, null, 8, ["time"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('common.selected')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(selectedTwisterValues.value) + " " + _toDisplayString(__props.quantity) + _toDisplayString(_ctx.$t('common.piece')), 1)]), _createVNode(_component_pop_up, {
        show: popupConfig.isShow,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => popupConfig.isShow = $event),
        title: popupConfig.title,
        content: popupConfig.content,
        "btn-confirm-text": _ctx.$t('button.DETERMINE')
      }, null, 8, ["show", "title", "content", "btn-confirm-text"])]);
    };
  }
};